import {SERVICE_NAME} from 'common/constants';
import {SurveyId} from 'common/models/survey';
import i18n from 'ui/i18n';
import getSurveyPath, {Path} from 'ui/utils/getSurveyPath';

import {shareTitleByType} from './Share.constants';
import {ShareInfo, ShareType} from './Share.types';

export const getShareType = (stats: boolean, results: boolean): ShareType => {
    if (results) {
        return ShareType.Results;
    }
    if (stats) {
        return ShareType.Stats;
    }
    return ShareType.Form;
};

const getShareLink = (type: ShareType, surveyId: SurveyId, answerKey: string): string => {
    const info: {query: Record<string, string>; path?: Path} = {
        query: {utm_source: 'share2', utm_content: 'success'},
    };

    if (type !== ShareType.Form) {
        info.path = 'success';
        info.query = Object.assign(
            info.query,
            {akey: answerKey},
            type === ShareType.Stats ? {utm_source: 'share-stats'} : {share: 'true'},
        );
    }

    const origin = window.location.origin;
    const path = getSurveyPath({
        withBase: true,
        surveyId,
        path: info.path,
    });
    const searchParams = new URLSearchParams(info.query);

    return origin + path + `?${searchParams.toString()}`;
};

interface GetShareInfoParams {
    surveyId: SurveyId;
    answerKey: string;
    scores?: string;
    totalScores?: string;
    title?: string;
    surveyName?: string;
}

export const getShareInfo = (
    type: ShareType,
    {surveyId, answerKey, scores, totalScores, surveyName, title}: GetShareInfoParams,
): ShareInfo => {
    let text = surveyName ? `${surveyName} — ${SERVICE_NAME}` : SERVICE_NAME;

    if (type === ShareType.Results) {
        text =
            i18n('success-page', 'scores', {
                count: scores,
                scores,
                totalScores,
            }) + ` — ${title}`;
    }

    return {
        blockTitle: shareTitleByType[type],
        link: getShareLink(type, surveyId, answerKey),
        text,
    };
};
